module.exports = __webpack_public_path__ + "static/media/1004.099baafc.jpg";